module.exports = __webpack_public_path__ + "media/volumecheck.6de21209.wav";